import React, {useState, useEffect} from 'react'
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {getProjectForms, getProjectFormAccess, saveProjectFormAccess} from "../../../../services/projectService";
import Radio from "@mui/material/Radio";
import {logActivity} from "../../../../services/utilService";
import { toaster } from '../../../../config';

function FormAccessDialog({user, handleMenuClose, Project_ID}) {
    const [open, setOpen] = useState(false);
    const [formPermissions, setFormPermissions] = useState([]);
    const accessTypes = ['Edit', 'View', 'Hide'];

    const handleClickOpen = () => {
        handleMenuClose(); // close action menu
        setOpen(true);

        // get all forms in project and user's form permissions
        Promise.all([getProjectForms(Project_ID), getProjectFormAccess(user.Username, Project_ID)])
            .then(responses => {
                const [projectFormsResponse, formAccessResponse] = responses;
                let formsData = projectFormsResponse.data;
                let formAccessData = formAccessResponse.data;
                if (typeof formsData === 'string') throw new Error(formsData);
                if (typeof formAccessData === 'string') throw new Error(formAccessData);

                // add access_type key to project forms and update with user's form access
                let updatedFormPermissions = formsData.map(form => ({
                    Form_ID: form.Form_ID,
                    Form_Name: form.Form_Name,
                    Access_Type: 'Edit'
                }));
                for(let i = 0; i < formAccessData.length; i++) {
                    let idx = updatedFormPermissions.findIndex(f => f.Form_ID === formAccessData[i].Form_ID);
                    updatedFormPermissions[idx].Access_Type = formAccessData[i].Access_Type;
                }
                setFormPermissions(updatedFormPermissions);
            })
            .catch(e => {
                toaster('error', String(e));
            })
    }

    const handleChange = (value, idx) => {
        let updatedFormPermissions = [...formPermissions];
        updatedFormPermissions[idx].Access_Type = value;
        setFormPermissions(updatedFormPermissions);
    }
    const handleSave = () => {
        let filteredFormPermissions = formPermissions.filter(form => form.Access_Type !== 'Edit');
        saveProjectFormAccess(user.User_ID, Project_ID, filteredFormPermissions)
            .then(response => {
                if(response.data.includes('Error')) throw new Error(response.data);
                toaster('success', 'Saved');
                logActivity('/projectSettings', 'PROJECT_USER_FORM_ACCESS_SAVE_SUCCESS');
                setOpen(false);
            })
            .catch(e => {
                toaster('error', String(e));
                logActivity('/projectSettings', 'PROJECT_USER_FORM_ACCESS_SAVE_FAILED');
            })
    };

    return (
        <>
            <MenuItem onClick={handleClickOpen}>Edit Form Access</MenuItem>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
            >
                <DialogTitle title={'User ID: ' + user.User_ID}>Form Access Control: <b>{user.Name}</b></DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <table className="table table-hover table-borderless">
                            <thead className="border-bottom">
                                <tr>
                                    <th>Form Name</th>
                                    <th>Edit</th>
                                    <th>View</th>
                                    <th>Hide</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formPermissions.map((form, idx) => (
                                    <tr>
                                        <td className="pb-1 pt-1 align-middle" title={'Form ID: ' + form.Form_ID}>
                                            {form.Form_Name}
                                        </td>
                                        {accessTypes.map(type => (
                                            <td className="pb-1 pt-1 align-middle">
                                                <Radio
                                                    key={type + idx}
                                                    disabled={false}
                                                    checked={form.Access_Type === type}
                                                    value={type}
                                                    onChange={(e) => handleChange(e.target.value, idx)}
                                                    size="small"
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save
                    </button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default FormAccessDialog